namespace GeniuzPOS.InventoryReport {
    export interface IcReport04Form {
    }

    export class IcReport04Form extends Serenity.PrefixedContext {
        static formKey = 'InventoryReport.IcReport04';
    }
}
